module.exports = __webpack_public_path__ + "img/woman_white.f4e2bf26.svg";